import { render } from "./SubscriptionView.vue?vue&type=template&id=6bbd522c&scoped=true&ts=true"
import script from "./SubscriptionView.vue?vue&type=script&lang=ts"
export * from "./SubscriptionView.vue?vue&type=script&lang=ts"

import "./SubscriptionView.vue?vue&type=style&index=0&id=6bbd522c&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbd522c"]])

export default __exports__